import React from 'react';

import { PrivatePage } from '../../../components/private-page';
import { ctGameDefault, ctGameTitle } from '../../../constants/text';
import { ZoneLibraryGrid } from '../../../features/zone-library-grid';

export const ZoneManagement = () => {
  React.useEffect(() => {
    document.title = ctGameTitle + ' - Zones management';
    return () => {
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <PrivatePage
      className={'page-base--full'}
      breadcrumb={[
        { label: 'Dashboard', href: 'dashboard' },
        { label: 'Administration', href: '../administration' },
        {
          label: ' Zone Map Management',
          href: 'administration/zones/manage'
        }
      ]}
      pageTitle={'Administration'}>
      <ZoneLibraryGrid isGlobal isAdmin />
    </PrivatePage>
  );
};
